module.exports = __webpack_public_path__ + "static/media/spades_7.01677b55.png";